// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { PipedriveService } from "./pipedrive.service"
import { StripeService } from "./stripe.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./pipedrive.service"
export * from "./stripe.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const abonnementServiceRegistry = {
    pipedrive: new PipedriveService(),
    stripe: new StripeService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type AbonnementServiceRegistry = typeof abonnementServiceRegistry
